// «Nytt oppdrag» vokser nedover: hver seksjon vises når forrige er fullført.
// Ren funksjon av skjemaets tilstand, uten React.
import { findMassType, activeOptions } from './massCatalog';

export const STAGE_ORDER = ['flow', 'product', 'option', 'quantity', 'truck', 'places', 'account', 'price', 'extras'];

// form: { massPicked, massType, massOption, requireOption (valgfri: true krever undervalg selv om typen ikke gjør det), tons, pickupStreet, deliveryStreet,
//         placeProblem (tekst eller null), truckProblem (tekst eller null), accountNeeded, accountProblem,
//         quantityOptional (valgfri: true gjør mengde valgfri, f.eks. timeoppdrag; tom eller over 0 er gyldig) }
// Returnerer { visible, complete, next, canPublish }. next = første synlige seksjon som ikke er fullført.
export function orderStages(form, catalog) {
  const type = form.massPicked ? findMassType(form.massType, catalog) : null;
  const productDone = !!type && type.active === true;
  const options = productDone ? activeOptions(type) : [];
  const optionRequired = type?.subRequired === true || form.requireOption === true;
  const optionDone = productDone && (options.length === 0
    ? true
    : form.massOption
      ? options.some((o) => o.key === form.massOption)
      : !optionRequired);
  const qtyText = String(form.tons ?? '').trim();
  const quantityValid = form.quantityOptional === true ? (qtyText === '' || Number(form.tons) > 0) : Number(form.tons) > 0;
  const quantityDone = optionDone && quantityValid;
  const truckDone = quantityDone && !form.truckProblem;
  const hasStreet = (s) => String(s ?? '').trim() !== '';
  const placesDone = quantityDone && hasStreet(form.pickupStreet) && hasStreet(form.deliveryStreet) && !form.placeProblem;
  const accountNeeded = form.accountNeeded === true;
  const accountDone = placesDone && (!accountNeeded || !form.accountProblem);

  const visible = {
    flow: true,
    product: true,
    option: productDone && options.length > 0,
    quantity: optionDone,
    truck: quantityDone,
    places: quantityDone,
    account: placesDone && accountNeeded,
    price: accountDone,
    extras: accountDone,
  };
  const complete = {
    flow: true,
    product: productDone,
    option: optionDone,
    quantity: quantityDone,
    truck: truckDone,
    places: placesDone,
    account: accountDone,
    // Pris og ekstra er ikke steg som må fullføres: de regnes som ferdige når de vises.
    price: accountDone,
    extras: accountDone,
  };
  const next = STAGE_ORDER.find((k) => visible[k] && !complete[k]) ?? null;
  return { visible, complete, next, canPublish: visible.price };
}

// Sidene i «Nytt oppdrag». Hver seksjon (STAGE_ORDER) hører til én side.
export const PAGES = [
  { key: 'vare', title: 'Vare' },
  { key: 'mengde', title: 'Mengde' },
  { key: 'steder', title: 'Steder' },
  { key: 'pris', title: 'Pris og tid' },
  { key: 'tillegg', title: 'Tillegg og betaling' },
];

const PAGE_OF = { flow: 0, product: 0, option: 0, quantity: 1, truck: 1, places: 2, account: 3, price: 3, extras: 4 };

export const pageOf = (stage) => PAGE_OF[stage];

// Kan bestilleren gå videre fra siden? Siste side er ferdig når oppdraget kan publiseres.
export function pageComplete(stages, page) {
  const done = [
    stages.complete.option,
    stages.complete.quantity && stages.complete.truck,
    stages.complete.places,
    stages.complete.account,
    stages.canPublish,
  ];
  return done[page] === true;
}
